import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

import ChatApp from './pages/ChatApp';
import SignIn from './pages/SignIn';
import CanvasView from './components/chatapp/CanvasView';
import CunexCallback from './pages/CunexCallback';

const cunexCallbackPaths = [
  '/auth/callback',
  '/auth/student/callback',
  '/auth/staff/callback',
];

const App: React.FC = () => {
  return (
    <Router>
      <MainApp />
    </Router>
  );
};

const MainApp: React.FC = () => {
  return (
    <div className="App font-chula">
      <header className="App-header">
        <Routes>
          <Route path="/" element={<ChatApp />} />
          <Route path="/signin" element={<SignIn />} />
          {cunexCallbackPaths.map((path) => (
            <Route key={path} path={path} element={<CunexCallback />} />
          ))}
          <Route path="/canvas/:canvasId" element={<CanvasView />} />
        </Routes>
      </header>
    </div>
  );
};

export default App;
